The date & time the application was accepted from the candidate. This corresponds to the `Event.createDateTime` field in the GraphQL schema.
